import { LoanContextType } from "../types/loan-context-type";
import { loanBalanceEmpty } from "./loan-balance-empty";

export const loanContextEmpty: LoanContextType = {
  loan: undefined,
  balance: loanBalanceEmpty.data,
  refetch: () => Promise.resolve(),
  drawRequest: undefined,
  setDrawRequest: () => {},
  accountsReceivables: [],
  setAccountsReceivables: () => {},
  fees: [],
  setFees: () => {},
  cacheKey: "",
  isFetching: true,
};
